import Splide from '@splidejs/splide';

const benefits = {
    init: () => {
        const sharedOptions = {
            // type: 'loop',
            interval: 60000,
            autoplay: true,
            pauseOnHover: false,
            drag: false,
            perMove: 1,
            pagination: false,
            arrows: false,
            breakpoints: {
                768: {
                    fixedWidth: false,
                    perPage: 1,
                    pagination: true,
                }
            }
        }

        let gallerySplide = document.querySelector('.benefits-gallery .splide');
        let contentSplide = document.querySelector('.benefits-content .splide');
        let mobileSplide = document.querySelector('.benefits-mobile .splide');

        if ( gallerySplide && contentSplide && mobileSplide ) {

            const benefitsGallerySplide = new Splide( '.benefits-gallery .splide', {
                type: sharedOptions.type,
                interval: sharedOptions.interval,
                autoplay: sharedOptions.autoplay,
                pauseOnHover: sharedOptions.pauseOnHover,
                drag: sharedOptions.drag,
                perMove: sharedOptions.perMove,
                pagination: sharedOptions.pagination,
                arrows: sharedOptions.arrows,
                breakpoints: sharedOptions.breakpoints,
                updateOnMove: true,
                // focus: 1,
                // trimSpace: false,
                fixedWidth: 260,
                fixedHeight: 260
            } ).mount();
    
    
            const benefitsContentSplide = new Splide( '.benefits-content .splide', {
                type: sharedOptions.type,
                interval: sharedOptions.interval,
                autoplay: sharedOptions.autoplay,
                pauseOnHover: sharedOptions.pauseOnHover,
                drag: sharedOptions.drag,
                perMove: sharedOptions.perMove,
                pagination: sharedOptions.pagination,
                arrows: sharedOptions.arrows,
                breakpoints: sharedOptions.breakpoints
            } ).mount();
    
            const sliders = [ benefitsGallerySplide, benefitsContentSplide ];
            const benefitsPrevArrow = document.querySelector( '.benefits-content__arrow--prev' );
            const benefitsNextArrow = document.querySelector( '.benefits-content__arrow--next' );
            
            const moveSliders = ( arrow ) => {
                sliders.forEach(slider => {
                    if ( arrow == 'prev' ) {
                        slider.go( '<' );
                    } else if ( arrow == 'next' ) {
                        slider.go( '>' );
                    }
                });
            }
    
            benefitsPrevArrow.addEventListener( 'click', () => {
                moveSliders('prev');
            } );
            
            benefitsNextArrow.addEventListener( 'click', () => {
                moveSliders('next');
            } );
    
    
    
            const benefitsMobileSplide = new Splide( '.benefits-mobile .splide', {
                type: sharedOptions.type,
                interval: sharedOptions.interval,
                autoplay: sharedOptions.autoplay,
                perMove: sharedOptions.perMove,
                arrows: false
            } );
            
            benefitsMobileSplide.on( 'pagination:mounted', function ( data ) {
                // You can add your class to the UL element
                data.list.classList.add( 'splide__pagination--custom' );
            } );
              
            benefitsMobileSplide.mount();
            
        }
    }
}

export default benefits;